import { Slide } from "@jelly/lesson";

import { task as task05 } from "../../../../../task/course-02/lesson-09/task-05";

const task: Slide = {
  titleHtml:
    "Tonality of which of the following signals depicted below (in the form of FFT Average plots)<br>corresponds to the definition of 1 tonality unit?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task05.id,
        },
      },
    },
  },
};

export default task;
